import React, { useEffect, useState } from 'react';
import { CircleImage, DefaultButton, Logo } from 'shared/ui';
import styles from './header.module.scss';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { accessTokenStore, userStore } from 'entities/index';
import { observer } from 'mobx-react-lite';
import { useAppMediaQuery } from 'shared/hooks';

interface HeaderProps {
  hideSignUpButton?: boolean;
  hideSignInButton?: boolean;
  hideActions?: boolean;
  transparent?: boolean;
  signUpButtonText?: string;
}

export const Header: React.FC<HeaderProps> = observer(
  ({
    hideSignUpButton,
    hideSignInButton,
    hideActions = false,
    transparent = false,
    signUpButtonText = 'Попробовать бесплатно',
  }) => {
    const isTablet = useAppMediaQuery('tablet');
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
      if (!transparent) return;
      const handleScroll = () => setScrolled(window.scrollY > 100);
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
    }, [transparent]);

    function navigateToProfile() {
      navigate(AppLinks.OwnerProfileLink);
    }
    function navigateToSignIn() {
      navigate(AppLinks.SignInLink);
    }
    function navigateToSignUp() {
      navigate(AppLinks.SignUpLink);
    }

    return (
      <div
        className={`${styles.header__outer} ${transparent ? styles['header__outer--transparent'] : styles['header__outer--solid']} ${transparent && scrolled ? styles['header__outer--scrolled'] : ''}`}
      >
        <div className={styles.header__container}>
          <div className={styles.container__logo}>
            <Logo />
          </div>
          {!hideActions && (
            <div className={styles.container__actions}>
              {accessTokenStore.isAuth ? (
                <div
                  className={styles.container__button}
                  onClick={navigateToProfile}
                >
                  <div className={styles.button__full_name}>
                    {userStore.fio}
                  </div>
                  <div className={styles.button__image}>
                    <CircleImage
                      imgSrc={userStore.imgUrl}
                      imgSize={isTablet ? 35 : 50}
                    />
                  </div>
                </div>
              ) : hideSignUpButton && hideSignInButton ? null : (
                <>
                  {!hideSignUpButton && (
                    <DefaultButton
                      buttonText={signUpButtonText}
                      color="green"
                      onClick={navigateToSignUp}
                    />
                  )}
                  {!hideSignInButton && (
                    <DefaultButton
                      buttonText="Войти"
                      color="white"
                      onClick={navigateToSignIn}
                    />
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
);
